<lib-dialog yesText="MIGRATE TEAM TO WORKSPACE">
  <ng-template>
    <form fxLayout="column">
      <p>
        By moving this {{ 'team' | platformLabel }} to a workspace, you will:
      </p>
      <ul>
        <li>Add all {{ 'team' | platformLabel }} members to the workspace</li>
        <li>
          Add all {{ 'Team Custom Fields' | platformLabel }} to the workspace
        </li>
        <li>Add all Tracked Fields to the workspace</li>
      </ul>
      @if (workspaces && workspaces.length > 0) {
        <mat-form-field
          appearance="outline"
          floatLabel="always"
          class="dropdown-field"
        >
          <mat-label>Select Workspace</mat-label>
          <mat-select [formControl]="formGroup.controls.workspace">
            @for (workspace of workspaces; track workspace) {
              <mat-option [value]="workspace.id">
                {{ workspace.name }}
              </mat-option>
            }
          </mat-select>
          @if (formGroup.controls.workspace.hasError('required')) {
            <mat-error> Workspace is required</mat-error>
          }
        </mat-form-field>
      }
    </form>
    @if (saving) {
      <div class="waiting-spinner">
        <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
      </div>
    }
  </ng-template>
</lib-dialog>
